import React from 'react';
import { Table, TablePaginationConfig } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { LOYALTY_ACTION } from '../../../constants/define/translation';
import { CommonColumn, IndexColumn } from '../shared-column';
import { LoyaltyActionType } from '../../../types/loyaltyAction';
import ActionsColumn from './column/ActionsColumn';

interface LoyaltyActionTableProps {
  records: any;
  onRefresh: () => void;
  loading?: boolean;
  setIsOpenModal: Function;
  setDataRecord: Function;
  setLoading: Function;
  className?: string;
  pagination?: TablePaginationConfig;
}

const { Column } = Table;
export const LoyaltyActionTable = (props: LoyaltyActionTableProps) => {
  const { t } = useTranslation(LOYALTY_ACTION);
  const { pagination, records, loading, className } = props;

  return (
    <>
      <StyledTable dataSource={records} loading={loading} className={className} rowKey="id" pagination={pagination}>
        <Column
          title={t('table.title.index')}
          align="center"
          width={32}
          dataIndex="index"
          key="index"
          render={value => <IndexColumn value={value} />}
        />
        <Column
          title={t('table.title.annexActionId')}
          align="center"
          width={100}
          dataIndex="annexActionId"
          key="annexActionId"
          render={value => <CommonColumn value={value} />}
        />

        <Column
          title={t('table.title.name')}
          align="center"
          width={100}
          dataIndex="name"
          key="name"
          render={value => <CommonColumn value={value} />}
        />
        <Column
          title={t('table.title.feature')}
          align="center"
          width={100}
          dataIndex="feature"
          key="feature"
          render={value => <CommonColumn value={value} />}
        />

        <Column
          title={t('table.title.action')}
          align="left"
          key="action"
          width={100}
          render={(_, record: LoyaltyActionType) => <ActionsColumn record={record} {...props} />}
        />
      </StyledTable>
    </>
  );
};

const StyledTable = styled(Table)``;
